export default __webpack_public_path__ + "static/media/ShipporiMincho-Regular.fc476d93.ttf";